import NavigationUtil from 'utils/NavigationUtil';
import { gcPlusRoute } from 'routes/obfuscatedRoutes';

const rawContext = '/modern';
const encodedContext = encodeURIComponent(rawContext); // '%2Fmodern'

/**
 * Returns a url to the Subscriptions tab of the Settings page.
 *
 * If a featureUrl is provided, it will be used as the connectUrl parameter for the paywall.
 * The featureUrl's context ('/modern') will be removed if present.
 *
 * @param {string | null | undefined} featureUrl
 * @returns {string}
 */
export const getSubscriptionPageUrlRaw = (featureUrl = undefined, encodeFeatureUrl = true) => {
    if (featureUrl) {
        let context;
        if (encodeFeatureUrl) {
            featureUrl = encodeURIComponent(featureUrl);
            context = encodedContext;
        } else {
            context = rawContext;
        }

        if (featureUrl.startsWith(context)) {
            featureUrl = featureUrl.replace(context, '');
        }
    }
    return `/settings/${gcPlusRoute}${featureUrl ? `?connectUrl=${featureUrl}` : ''}`;
};

/**
 * Returns a url to the Subscriptions tab of the Settings page, prepended by the '/modern' context.
 *
 * If a featureUrl is provided, it will be used as the connectUrl parameter for the paywall.
 * The featureUrl's context ('/modern') will be removed if present.
 *
 * @param {string | null | undefined} featureUrl
 * @returns {string}
 */
export const getSubscriptionPageUrl = (featureUrl = undefined, encodeFeatureUrl = true) =>
    NavigationUtil.url(getSubscriptionPageUrlRaw(featureUrl, encodeFeatureUrl));

/**
 * Navigates to the Subscriptions tab of the Settings page.
 *
 * @param {string | null | undefined} featureUrl
 * @returns {boolean | undefined}
 */
export const navigateToSubscriptionPage = (featureUrl = undefined, e = undefined) =>
    NavigationUtil.navigate(getSubscriptionPageUrlRaw(featureUrl), e, undefined);
